import './sass/main.scss';

import './js/mobile-menu';
import './js/modal-order';
import './js/modal-about';
import './js/slick';
import './js/map-modal';
import './js/franchize-modal';
import './js/scroll-top';